// extracted by mini-css-extract-plugin
module.exports = {"icon":"unenroll-modal_icon__uNhew","description":"unenroll-modal_description__11awf","buttons":"unenroll-modal_buttons__2mN-t","checkboxIcon":"unenroll-modal_checkboxIcon__bDs_Z"};